import { render, staticRenderFns } from "./WebplayerLayout.vue?vue&type=template&id=53e10868"
import script from "./WebplayerLayout.vue?vue&type=script&lang=ts"
export * from "./WebplayerLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports